import { render, staticRenderFns } from "./UserTabsContainer.vue?vue&type=template&id=141168be&scoped=true"
import script from "./UserTabsContainer.vue?vue&type=script&lang=js"
export * from "./UserTabsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141168be",
  null
  
)

export default component.exports